module.exports = __webpack_public_path__ + "static/media/speakers_logos_Microsoft.50fcc556.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speakers_logos_Microsoft.jpg
// module id = 274
// module chunks = 0